import { useTranslation } from "react-i18next"
import { Card } from "../Card"
import { ProjectSettingGroup } from "./ProjectSettingGroup"
import { formatDateAsConnect } from "../../util/dateTools"

const ConnectProjectContext = (props: {
  region?: string
  description?: string
  name?: string
  startDate?: string
  endDate?: string
}) => {
  const { t } = useTranslation("config")

  return (
    <div className="row">
      <div className="col-12">
        <Card header={t("connectContext.header")}>
          <div className="col-12 col-lg-4">
            <p className="text-meta">{t("connectContext.description")}</p>
          </div>
          <div className="col-12 col-lg-8">
            <DetailsItem name={props.name} region={props.region} description={props.description} t={t} />
            <DatesItem startDate={props.startDate} endDate={props.endDate} t={t} />
          </div>
        </Card>
      </div>
    </div>
  )
}

const DetailsItem = (props: { name?: string; region?: string; description?: string; t: any }) => {
  const regionName = props.region
    ? props.region === "europe"
      ? props.t("connectContext.regionEurope")
      : props.t("connectContext.regionNorthAmerica")
    : undefined

  return (
    <ProjectSettingGroup
      name={props.t("connectContext.detailsHeading")}
      projectSettings={[
        { name: props.t("connectContext.projectName"), value: props.name },
        { name: props.t("connectContext.projectLocation"), value: regionName },
        { name: props.t("connectContext.projectDescription"), value: props.description }
      ]}
      optional={true}
      message={props.t("connectContext.notDefined")}
    />
  )
}

const DatesItem = (props: { startDate?: string; endDate?: string; t: any }) => {
  const startDate = props.startDate ? formatDateAsConnect(props.startDate) : undefined
  const endDate = props.endDate ? formatDateAsConnect(props.endDate) : undefined

  return (
    <ProjectSettingGroup
      name={props.t("connectContext.datesHeading")}
      projectSettings={[
        { name: props.t("connectContext.projectStartDate"), value: startDate },
        { name: props.t("connectContext.projectEndDate"), value: endDate }
      ]}
      optional={true}
      message={props.t("connectContext.notDefined")}
    />
  )
}

export default ConnectProjectContext
